<template>
    <div>
        <div class='mcf-page-background'></div>
        <div class="mcf-page-editor">
            <div class="mcf-page-editor-form">
                <div class="mcf-page-editor-header">
                    <label>Imprimer</label>
                </div>
                <div class="mcf-page-editor-menu">
                    <button v-for="bt of setting.buttons" :key="bt.id" @click="bt_load_print(bt)">
                        <i class="fa fa-print"></i>
                        <label>{{bt.label}}</label>
                    </button>
                    <button>
                        <i class="fa fa-download"></i>
                        <a :href="setting.data" :download="setting.title+'.pdf'">Télécharger</a>
                    </button>
                    <button @click="bt_close">
                        <i class="fa fa-close"></i>
                        <label>Annuler</label>
                    </button>
                </div>
                <div class="mcf-page-editor-content">
                    <iframe :src="setting.data" download="test.pdf" style="position:absolute;width:100%;height:100%;left:0px;" frameborder='0'></iframe>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import {DateTime} from "luxon";

export default {
    props:{
        setting:Object,
        close:Function
    },
    data(){
        return {
            
        };
    },
    created() {
        
    },
    methods:{
        bt_close:function(){
            this.close();
        },
        bt_load_print: async function(b){
            var tmain = this;
            var info = await b.fx();
            tmain.setting.data = info;
        }
    }
}
</script>